import React, { useEffect } from 'react';
import './ConfirmDialog.css';

/**
 * In-app replacement for window.confirm / window.alert - styled like
 * the rest of the site instead of an OS prompt.
 *
 * confirm mode: pass onConfirm (and optionally onCancel)
 * notice mode:  omit onConfirm - single OK button fires onCancel
 */
function ConfirmDialog({
    open,
    title,
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    danger = false,
    busy = false,
    onConfirm,
    onCancel,
}) {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => { if (e.key === 'Escape' && onCancel) onCancel(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [open, onCancel]);

    if (!open) return null;

    return (
        <div className="cdlg-overlay" onClick={() => !busy && onCancel && onCancel()}>
            <div className="cdlg" role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
                {title && <h3 className="cdlg-title">{title}</h3>}
                {message && <div className="cdlg-message">{message}</div>}
                <div className="cdlg-actions">
                    {onConfirm ? (
                        <>
                            <button className="cdlg-btn" disabled={busy} onClick={onCancel}>
                                {cancelLabel}
                            </button>
                            <button
                                className={`cdlg-btn cdlg-primary${danger ? ' cdlg-danger' : ''}`}
                                disabled={busy}
                                onClick={onConfirm}
                            >
                                {confirmLabel}
                            </button>
                        </>
                    ) : (
                        <button className="cdlg-btn cdlg-primary" onClick={onCancel}>
                            OK
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ConfirmDialog;
